import { getAmpConfig } from 'src/services/amp-config.service';

export type ApiServices =
  | 'retail'
  | 'retailComposite'
  | 'entryways'
  | 'onboarding'
  | 'clientState'
  | 'assignment'
  | 'roster'
  | 'events'
  | 'portfolioBFF'
  | 'classStats'
  | 'insights'
  | 'studentDesmos'
  | 'sharedExpBff';

export const getApiUrl = (service: ApiServices) => {
  const map = {
    retailComposite: `${getAmpConfig().gateway}/retail-composite`,
    retail: `${getAmpConfig().retail}/api/licensing`,
    entryways: `${getAmpConfig().amplifyMES}`,
    onboarding: getAmpConfig().onboarding,
    clientState: `${getAmpConfig().gateway}/client-state-service/state`,
    assignment: `${getAmpConfig().gateway}/assignment-service`,
    roster: getAmpConfig().roster,
    events: getAmpConfig().events,
    portfolioBFF: getAmpConfig().portfolioBFF,
    classStats: `${getAmpConfig().gateway}/class-stats-svc`,
    insights: `${getAmpConfig().gateway}/insights`,
    studentDesmos: `${getAmpConfig().desmosStudent}`,
    sharedExpBff: `${getAmpConfig().gateway}/shared-exp-bff`,
  };

  return map[service];
};
